var _defs, _path, _path2, _rect, _rect2, _rect3, _line, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.3 41.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n        stroke-width: .6px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4,25.4v-13.8c0-1.9-1.5-3.4-3.4-3.4s-3.4,1.5-3.4,3.4h0v13.8c-2.2,1.9-2.4,5.2-.5,7.4,1,1.1,2.4,1.8,3.9,1.8h0c2.9,0,5.3-2.4,5.3-5.3,0-1.5-.7-3-1.8-4M16.2,32.6c-.9.9-2,1.3-3.2,1.3-2.5,0-4.5-2.1-4.5-4.6,0-1.3.6-2.6,1.7-3.5,0,0,.1-.2.1-.3v-14c0-1.5,1.3-2.7,2.7-2.7,1.5,0,2.6,1.2,2.7,2.7v14c0,.1,0,.2.1.3,1.9,1.6,2.2,4.4.7,6.4-.1.1-.2.3-.3.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1,26.7l-.5-.4v-14h-3.2v14l-.5.4c-1.5,1.2-1.7,3.3-.5,4.8.6.8,1.6,1.3,2.6,1.3h0c1.9,0,3.4-1.5,3.4-3.4s-.5-2-1.3-2.7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.2,
    y: 22.1,
    width: 3.1,
    height: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2,
    y: 19.6,
    width: 2.6,
    height: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2,
    y: 17,
    width: 3.1,
    height: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.4,
    y1: 19.7,
    x2: 27.3,
    y2: 23.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7,14.3l-4.7,7h2.6c.1,0,.2.1.2.2v8.5h3.6v-8.5c0-.1.1-.2.2-.2h2.6l-4.7-7.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp);
export default __webpack_public_path__ + "static/media/TEMP.46b628791a1c3bb73d31e1d43f0df615.svg";
export { ForwardRef as ReactComponent };